<app-tag-item
	*ngFor="let tagItem of tagListConfig?.tags; let index=index;"
	class="d-inline-block col-12 col-md-auto px-0 my-1"
	[ngClass]="{
		'me-md-2': index < tagListConfig?.tags.length - 1
	}"
	[tag]="tagItem"
>
	<ng-template
		#tagItemTpl
		let-tagItem="tagItem"
	>
		<ng-template
			[ngTemplateOutlet]="tagListItemTpl"
			[ngTemplateOutletContext]="{ tagItem }"
		></ng-template>
	</ng-template>
</app-tag-item>
